import { Heart, Check } from "lucide-react";

/**
 * Right Match logo — a maroon heart with a gold-rimmed white check inside.
 * "The right (✓) match (♥)" — symbolic of considered, verified matchmaking.
 */
export default function Logo({ size = "h-7 w-7", checkSize = "h-3.5 w-3.5", strokeWidth = 1.2 }) {
  return (
    <span className={`relative inline-flex items-center justify-center ${size}`} aria-hidden="true">
      <Heart className={`${size} text-brand-maroon`} fill="#7A1C28" strokeWidth={strokeWidth} />
      <Check
        className={`absolute ${checkSize} text-white`}
        strokeWidth={3.2}
        style={{ top: "44%", left: "50%", transform: "translate(-50%, -50%)" }}
      />
    </span>
  );
}

/** Brand wordmark + logo. Useful in Navbar and auth screens. */
export function LogoMark({ tone = "maroon", size = "text-2xl", className = "" }) {
  const color = tone === "white" ? "text-white" : "text-brand-maroon";
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <Logo />
      <span className={`font-serif tracking-wide ${size} ${color}`}>
        Right<span className="text-brand-gold italic"> Match</span>
      </span>
    </span>
  );
}
